import { FC } from 'react';

interface EmojiProps {
  unified: string;
  className?: string;
}

const Emoji: FC<EmojiProps> = ({ unified, className }) => {
  return <span className={className}>{String.fromCodePoint(parseInt(`0x${unified}`, 16))}</span>;
};
export default Emoji;
